import React, { useState, useEffect } from "react";
import { useExam } from "../../context/ExamContext";
import stringQuestionIntervalToArray from "../../utils/stringQuestionIntervalToArray";
import useScrollToActiveQuestion from "../../hooks/useScrollToActiveQuestion";

function MultipleSelect({ questionSet }) {
  const { commonQuestion, answerOptions, questionInterval } = questionSet;
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const { updateAnswer, removeAnswer, setActiveQuestion, answers } = useExam();
  const allSetQuestionNumbers = stringQuestionIntervalToArray(questionInterval);
  const { activeQuestion } = useExam();
  const scrollRef = useScrollToActiveQuestion(allSetQuestionNumbers);

  useEffect(() => {
    if (answers && Array.isArray(answers)) {
      const prefilledAnswers = {};
      answers
        .filter((opt) => allSetQuestionNumbers.some((num) => opt.questionNumber == num))
        .filter(({ answer }) => answer != null && answer !== "")
        .forEach(({ questionNumber, answer }) => {
          prefilledAnswers[answer] = questionNumber; // Map answer value to questionNumber
        });
      setSelectedAnswers(prefilledAnswers);
    }
  }, [answers]);

  const handleCheckboxChange = (selectedOption) => {
    setSelectedAnswers((prev) => {


      if (prev[selectedOption.key]) {
        const questionNumberToRemove = prev[selectedOption.key];

        if (!questionNumberToRemove) {
          console.error("Error: No question number available for removal:", selectedOption);
          return prev;
        }

        removeAnswer(questionNumberToRemove);

        const newState = { ...prev };
        delete newState[selectedOption.key];

        return newState;
      }

      const usedQuestionNumbers = Object.values(prev);
      const availableQuestionNumber = allSetQuestionNumbers.find(
        (qn) => !usedQuestionNumbers.includes(qn)
      );

      if (!availableQuestionNumber) {
        // console.error("Error: No available question numbers for selection:", selectedOption);
        return prev;
      }
      setActiveQuestion(availableQuestionNumber);
      updateAnswer({
        questionNumber: availableQuestionNumber,
        answer: selectedOption.key, // Send the actual answer text
        answerLabel: selectedOption.answer, // Send the assigned key (A, B, C...)
      });

      return { ...prev, [selectedOption.key]: availableQuestionNumber };
    });
  };

  return (
    <div ref={scrollRef}>
      <div style={{ display: "flex", alignItems: "center", fontSize: 16, lineHeight: "1.8em", whiteSpace: "pre-wrap", gap: "10px" }}>
        <span
          style={{
            border: allSetQuestionNumbers.includes(activeQuestion)
              ? "2px solid #3B82F6"
              : "2px solid transparent",
            padding: "0 4px",
            fontWeight: "bold",
            borderRadius: "4px",
            boxSizing: "border-box",
            marginLeft: "-6px"
          }}
        >
          {questionInterval}
        </span>
        <div dangerouslySetInnerHTML={{ __html: commonQuestion }} />
      </div>

      <div>
        {answerOptions.length > 0 ? (
          answerOptions.map((option) => {
            const isChecked = selectedAnswers.hasOwnProperty(option.key);
            return (
              <label key={option.answer} style={{ display: "block" }}>
                <input
                  type="checkbox"
                  value={option.answer}
                  checked={isChecked}
                  onChange={() => handleCheckboxChange(option)}
                />
                <strong>{option.key} </strong>{option.answer}
              </label>
            );
          })
        ) : (
          <p>No options available</p>
        )}
      </div>
    </div>
  );
}

export default MultipleSelect;
